import * as React from 'react';
import PharmacyMarker from './PharmacyMarker';
import { generateBasicIcon } from '../../common/icons';
import config from '../../config';
import { LoadScript, GoogleMap, Circle, MarkerClusterer } from '@react-google-maps/api';

interface PharmacyMapComponentProps {
  center: google.maps.LatLngLiteral;
  onMapLoad: (map: google.maps.Map) => void;
  places: any;
  neighbors: any[];
}

const PharmacyMapComponent = (props: PharmacyMapComponentProps) => {
  return (
    <LoadScript googleMapsApiKey={config.googleMapApiKey}>
      <GoogleMap
        zoom={8}
        center={props.center}
        options={{ gestureHandling: 'greedy', scaleControl: true }}
        onLoad={props.onMapLoad}
        mapContainerStyle={{ height: `600px`, width: '100%' }}
      >
        <MarkerClusterer gridSize={20}>
          {(clusterer) => {
            let markers = props.places.map((marker) => (
              <PharmacyMarker
                key={'Place' + marker.pharmacyId}
                marker={marker}
                icon={generateBasicIcon(marker.level, false, false, false, false)}
              />
            ));

            if (props.neighbors) {
              const neighborsMarkers = props.neighbors
                .filter((i) => i !== undefined)
                .map(
                  (pharmacy) =>
                    pharmacy.isActive && (
                      <PharmacyMarker
                        key={'Neighbors1' + pharmacy.pharmacyId}
                        marker={pharmacy}
                        icon={generateBasicIcon(pharmacy.level, false, false, false, false)}
                      />
                    ),
                );
              markers = markers.concat(neighborsMarkers);
            }

            if (props.places[0].minDistance) {
              markers = markers.concat(
                <Circle
                  key={'min23458'}
                  center={props.center}
                  radius={props.places[0].minDistance}
                  options={{
                    fillColor: '#106BA3',
                    strokeWeight: 0.5,
                  }}
                />,
              );
            }

            if (props.places[0].maxDistance) {
              markers = markers.concat(
                <Circle
                  key={'min23458'}
                  center={props.center}
                  radius={props.places[0].maxDistance}
                  options={{
                    fillColor: '#106BA3',
                    strokeWeight: 0.5,
                  }}
                />,
              );
            }

            return markers;
          }}
        </MarkerClusterer>
      </GoogleMap>
    </LoadScript>
  );
};

export default PharmacyMapComponent;
